import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES = ['Route Id', 'Description'];

export const AddressRouteDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'routeID',
    params: { windowId: 'routes' },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={options} columnNames={COLUMN_NAMES} />;
};
